/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/progress-bar/custom-elements';

import { defineCustomElement as defineOsdsProgressBar } from '@ovhcloud/ods-stencil/components/progress-bar/custom-elements/osds-progress-bar.js';


export const OsdsProgressBar = /*@__PURE__*/ defineContainer<JSX.OsdsProgressBar>('osds-progress-bar', defineOsdsProgressBar, [
  'max',
  'value'
]);

